import "./Services.css";
import React from "react";
import { Link } from "react-router-dom";

function Services() {
  const womensHealth = [
    {
      category: "Routine & preventive",
      items: [
        { name: "Gynaecological and routine check-ups", desc: "Pap smears, pelvic exams and breast health assessments to detect potential issues early." },
        { name: "Cervical vaccination", desc: "Gardasil 9 and Gardasil HPV vaccines to protect against cervical cancer." },
        { name: "Menstrual disorders", desc: "Advanced diagnosis and treatment for irregular, painful or heavy periods, contraception and related hormonal issues." },
        { name: "PCOS Power Protocol", desc: "Lifestyle change, medication and monitoring, designed to restore hormonal balance." },
        { name: "Contraception & family planning", desc: "Expert advice on the options that suit your lifestyle and health needs." }
      ]
    },
    {
      category: "Pregnancy & motherhood",
      items: [
        { name: "Pregnancy consultation", desc: "Care from the first visit onward, so pregnancy is the safest and happiest experience it can be." },
        { name: "Normal delivery facility", desc: "A 90% normal delivery rate, with epidural options for painless delivery." },
        { name: "High-risk pregnancy care", desc: "Advanced diagnostics and management of complications for the best outcome for mother and child." },
        { name: "Lactation support", desc: "Personalised help for breastfeeding mothers facing lactation insufficiency." },
        { name: "Infertility treatment", desc: "The latest diagnostic tools and individualised therapy to address the underlying causes." }
      ]
    },
    {
      category: "Specialised gynaecology",
      items: [
        { name: "Laparoscopic surgery", desc: "Minimally invasive keyhole surgery for faster recovery and minimal scarring." },
        { name: "High-risk obstetrics", desc: "Close monitoring for pre-existing medical conditions and gestational complications." },
        { name: "Menopause treatment options", desc: "Managing hot flashes, bone density changes and hormonal balance through the menopausal transition." },
        { name: "Fibroid and cyst management", desc: "Non-surgical and surgical options for uterine fibroids and ovarian cysts." },
        { name: "Endometriosis management", desc: "Pain management, medication and surgical solutions tailored to each patient." }
      ]
    }
  ];

  const paediatrics = [
    {
      category: "The early years",
      items: [
        { name: "Newborn care", desc: "Newborn screening and tests, feeding advice for breastfed and formula-fed babies, and developmental milestone checks." },
        { name: "Routine health check-ups", desc: "Physical examinations, growth monitoring, developmental assessments and vaccination updates." },
        { name: "Paediatric vaccinations", desc: "Infant vaccines, childhood immunisations and boosters for older children." },
        { name: "Vision and hearing tests", desc: "Screening for the early detection of problems that are easiest to correct young." }
      ]
    },
    {
      category: "Illness & treatment",
      items: [
        { name: "Childhood illnesses", desc: "Respiratory infections, gastrointestinal problems, ear infections, skin rashes and allergies." },
        { name: "Asthma and allergy management", desc: "Asthma diagnosis and treatment, allergy testing and personalised asthma care plans." },
        { name: "Paediatric dermatology", desc: "Eczema, rashes, psoriasis and other skin disorders in children." },
        { name: "Growth and development counselling", desc: "Weight and nutrition, healthy eating habits and growth delays." }
      ]
    },
    {
      category: "Growing up",
      items: [
        { name: "Mental health support", desc: "Help with behavioural issues, anxiety and depression, sleep disorders and emotional wellbeing." },
        { name: "Adolescent health care", desc: "Puberty-related issues, mental health support, sexual health education and preventive care." },
        { name: "Adolescent counselling for girls", desc: "Gentle guidance through the physical and emotional changes of the teenage years." },
        { name: "Weight management", desc: "Professional support for adolescents where diet and exercise alone have not been enough." }
      ]
    }
  ];

  return (
    <>
      {/* WOMEN'S HEALTH */}
      <section className="band" id="womens-health">
        <div className="wrap">
          <div className="svc-head">
            <div>
              <p className="eyebrow">Women's health</p>
              <h2 className="h-sec">Experienced gynaecology in Malleswaram.</h2>
            </div>
            <div>
              <p className="body-copy">
                Gynaecology focuses on the health of the female reproductive system &mdash; the uterus, ovaries, fallopian tubes and related organs. Under Dr. Nishita Rao, MBBS, MS (Obstetrics and Gynaecology), we provide expert pregnancy care, maternity care and advanced infertility treatment.
              </p>
              <p className="body-copy">
                We use laparoscopic techniques for minimally invasive surgery, hysteroscopy and advanced imaging for accurate diagnosis and personalised treatment, which shortens healing time considerably.
              </p>
              <div style={{ marginTop: '16px' }}>
                <Link to="/services/gynaecology" className="btn-ghost">
                  Learn more about women's health &rarr;
                </Link>
              </div>
            </div>
          </div>
          <div className="svc-cols">
            {womensHealth.map((col, idx) => (
              <div className="svc-col" key={idx}>
                <h4>{col.category}</h4>
                <ul className="svc-list">
                  {col.items.map((it, itIdx) => (
                    <li key={itIdx}>
                      <b>{it.name}</b>
                      <span>{it.desc}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* PAEDIATRICS */}
      <section className="band tint" id="paediatrics">
        <div className="wrap">
          <div className="svc-head">
            <div>
              <p className="eyebrow">Child care</p>
              <h2 className="h-sec">Paediatrics, from the first week onward.</h2>
            </div>
            <div>
              <p className="body-copy">
                Whether it is a newborn or a growing adolescent, every parent wants a doctor they can trust with the needs of their child at each stage. Dr. Mahesh Rao has been treating children for over two decades, and our clinic is equipped with modern diagnostic tools.
              </p>
              <p className="body-copy">
                We focus on making every visit as comfortable as possible &mdash; a friendly, calm environment for children and parents alike.
              </p>
              <div style={{ marginTop: '16px' }}>
                <Link to="/services/pediatric" className="btn-ghost">
                  Learn more about paediatrics &rarr;
                </Link>
              </div>
            </div>
          </div>
          <div className="svc-cols">
            {paediatrics.map((col, idx) => (
              <div className="svc-col" key={idx}>
                <h4>{col.category}</h4>
                <ul className="svc-list">
                  {col.items.map((it, itIdx) => (
                    <li key={itIdx}>
                      <b>{it.name}</b>
                      <span>{it.desc}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* GENERAL SERVICES */}
      <section className="band" id="general">
        <div className="wrap">
          <div className="split">
            <div>
              <p className="eyebrow">General services</p>
              <h2 className="h-sec">The rest of what a family needs.</h2>
              <p className="body-copy" style={{ marginTop: "24px" }}>
                Alongside our specialised services in maternity care and women's health, we provide general medical services: primary healthcare, internal medicine, minor surgical procedures, health screenings, and the management of acute and chronic illness.
              </p>
              <p className="body-copy">
                Our physicians and healthcare professionals work together to offer comprehensive, personalised care to patients of all ages &mdash; whether it is a routine check-up, a diagnostic evaluation or ongoing medical management.
              </p>
              <div style={{ display: 'flex', gap: '14px', flexWrap: 'wrap', marginTop: "28px" }}>
                <Link className="btn-solid" to="/appointment">
                  Book a consultation
                </Link>
                <Link className="btn-ghost" to="/services/general-services">
                  General services &rarr;
                </Link>
              </div>
            </div>
            <div>
              <figure className="fig fig-wide">
                <img
                  src="/img/uplaods/mother-loves-her-child.avif"
                  alt="Parents with their sleeping newborn"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/img/uplaods/General-services.webp";
                  }}
                />
              </figure>
              <figcaption className="fig-cap">
                Families stay with us long after the delivery room.
              </figcaption>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Services;